import template from './iframeFix.html';

export const iframeFixComponent = {
  name: 'iframeFix',
  restrict: 'E',
  template
};
